const BASE_URL = '/api';

async function fetchJSON(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}: ${url}`);
  return res.json();
}

export function getCompetencias() {
  return fetchJSON(`${BASE_URL}/dashboard/competencias`);
}

export function getDashboardGeral(competenciaId) {
  return fetchJSON(`${BASE_URL}/dashboard/geral?competencia=${competenciaId}`);
}

export function getDashboardEquipes(competenciaId) {
  return fetchJSON(`${BASE_URL}/dashboard/equipes?competencia=${competenciaId}`);
}

// ============ ABA ANÁLISE INDIVIDUAL ===========
export function getAnaliseIndividual(competenciaId, regiao = null, equipe = null) {
  const params = new URLSearchParams();
  params.append('competencia', competenciaId);
  if (regiao) params.append('regiao', regiao);
  if (equipe) params.append('equipe', equipe);
  return fetchJSON(`${BASE_URL}/dashboard/analise-individual?${params.toString()}`);
}

export function getAnaliseIndividualRegioes(competenciaId) {
  return fetchJSON(`${BASE_URL}/dashboard/analise-individual/regioes?competencia=${competenciaId}`);
}

export function getAnaliseIndividualEquipes(competenciaId, regiao) {
  return fetchJSON(`${BASE_URL}/dashboard/analise-individual/equipes?competencia=${competenciaId}&regiao=${encodeURIComponent(regiao)}`);
}

// ============ ABA ROTA ===========
export function getRota(competenciaId, regiao = null, equipe = null, dia = null) {
  const params = new URLSearchParams();
  params.append('competencia', competenciaId);
  if (regiao) params.append('regiao', regiao);
  if (equipe) params.append('equipe', equipe);
  if (dia) params.append('data', dia);
  return fetchJSON(`${BASE_URL}/dashboard/rota?${params.toString()}`);
}

export function getRotaRegioes(competenciaId) {
  return fetchJSON(`${BASE_URL}/dashboard/rota/regioes?competencia=${competenciaId}`);
}

export function getRotaEquipes(competenciaId, regiao) {
  return fetchJSON(`${BASE_URL}/dashboard/rota/equipes?competencia=${competenciaId}&regiao=${regiao}`);
}